import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { YardList, AddYardModal } from "../../components/stock";
import { StockService } from "../../services/stock.service";
import { PageHeader, CardLayout } from "../../components/v3";

export const Yards = () => {
  const [yards, setYards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [inputData, setInputData] = useState({
    yardName: "",
    yardLocation: "",
  });

  const childRefYard = useRef();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setLoading(true);
    const yardsList = StockService.getYards();
    setYards(yardsList);
    setLoading(false);
  };

  const handleAddYard = () => {
    childRefYard.current.onShowModal();
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCloseModal = () => {
    setShow(false);
    setInputData({
      yardName: "",
      yardLocation: "",
    });
  };

  const handleSubmit = () => {
    // TODO: handle this case while API integration
    const response = StockService.createYard(inputData);
    console.log(`🚀 ~ handleSubmit ~ response:`, response);

    fetchData();
    setInputData({
      yardName: "",
      yardLocation: "",
    });
    setShow(false);
    toast("Yard added successfully", { type: "success" });
  };

  return (
    <>
      <PageLayout>
        <PageHeader
          title="Yards"
          subtitle={`${yards.length} Yards`}
          buttons={[{ buttonText: "Add Yard", buttonIcon: Add, onClick: handleAddYard }]}
        />
        <CardLayout>
          <YardList />
        </CardLayout>
      </PageLayout>

      <AddYardModal
        ref={childRefYard}
        show={show}
        setShow={setShow}
        inputData={inputData}
        handleChange={handleChange}
        handleCloseModal={handleCloseModal}
        handleSubmit={handleSubmit}
      />
    </>
  );
};
